import {fromJS} from "immutable";
import {CHANGE_REDIRECT_URL} from "./constants";

export const initialState = fromJS({
    redirectState: ''
});

function redirectStateReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_REDIRECT_URL:
            return state.set('redirectState', action.redirectState);
        default:
            return state;
    }
}

export default redirectStateReducer;


// WEBPACK FOOTER //
// ./src/redux/global/redirect/reducer.js